import moment from "moment";
import {
  texto,
  identificador,
  numero,
  moneda,
  fecha,
  centro,
  construirHojaTabla,
  limpiarNombreArchivo,
  descargarLibro,
} from "../../../Components/ExcelTablaReporte";

/**
 * Excel de la pestaña "Estado de Ventas" del Diagnóstico: ventas en estado 2 o 3 cuyo estado
 * no cuadra con lo entregado en sus líneas.
 */

// Venta.estado de entrega, mismas etiquetas que ModalPrevisualizarVenta (0 = cancelada no se
// asigna desde el diagnóstico: cancelar tiene su propio flujo con reversos).
export const ESTADOS_ENTREGA_VENTA = {
  1: "Sin entregar",
  2: "Entregado parcialmente",
  3: "Entregado",
};

// Ya tiene salidas de inventario y lo entregado sugiere "Sin entregar": si se regresa a 1 y se
// vuelve a entregar, el inventario se descuenta dos veces.
export const tieneSalidasSinEntrega = (venta) => venta.salidas > 0 && venta.estadoSugerido === 1;

// Sin líneas válidas (todas mal guardadas) no hay de dónde sugerir un estado: hay que revisar la venta.
export const TEXTO_SIN_SUGERIDO = "Revisar líneas";

// Se sigue listando mientras su estado no cuadre o tenga líneas mal guardadas.
export const sigueConProblema = (venta) => venta.estado !== venta.estadoSugerido || venta.lineasInvalidas > 0;

export const tipoVenta = (venta) => (venta.factura ? "Factura" : venta.remision ? "Remisión" : "Venta");

const COLUMNAS = [
  { titulo: "Folio", tipo: "texto", ancho: 18 },
  { titulo: "Tipo", tipo: "centro", ancho: 11 },
  { titulo: "Fecha", tipo: "fecha", ancho: 12 },
  { titulo: "Cliente", tipo: "texto", ancho: 36 },
  { titulo: "Total", tipo: "moneda", ancho: 16 },
  { titulo: "Estado actual", tipo: "texto", ancho: 22 },
  { titulo: "Estado sugerido", tipo: "texto", ancho: 22 },
  { titulo: "Líneas", tipo: "numero", ancho: 9 },
  { titulo: "Líneas completas", tipo: "numero", ancho: 10 },
  { titulo: "Líneas mal guardadas", tipo: "numero", ancho: 12 },
  { titulo: "Cantidad", tipo: "numero", ancho: 11 },
  { titulo: "Entregado", tipo: "numero", ancho: 11 },
  { titulo: "Salidas de inventario", tipo: "numero", ancho: 12 },
  { titulo: "Venta ID", tipo: "identificador", ancho: 27 },
];

const construirTabla = (ventas) => {
  const filas = (ventas || []).map((venta) => {
    const celdas = [
      texto(venta.serieNumero),
      centro(tipoVenta(venta)),
      fecha(venta.fecha),
      texto(venta.nombreCliente),
      moneda(venta.total),
      texto(ESTADOS_ENTREGA_VENTA[venta.estado] || venta.estado),
      texto(ESTADOS_ENTREGA_VENTA[venta.estadoSugerido] || TEXTO_SIN_SUGERIDO),
      numero(venta.totalLineas),
      numero(venta.lineasCompletas),
      numero(venta.lineasInvalidas || 0),
      numero(venta.cantidadTotal),
      numero(venta.entregadoTotal),
      numero(venta.salidas),
      identificador(venta.ventaId),
    ];
    return tieneSalidasSinEntrega(venta) || venta.lineasInvalidas > 0
      ? celdas.map((celda) => ({ ...celda, resalte: "nota" }))
      : celdas;
  });

  // Sin fila de totales: sumar importes de ventas con estados distintos no significa nada aquí.
  return { columnas: COLUMNAS, filas };
};

export const descargarExcelVentasEstadoIncorrecto = ({ ventas, empresaNombre }) => {
  descargarLibro(
    [
      {
        nombre: "Estado de Ventas",
        hoja: construirHojaTabla(construirTabla(ventas), {
          titulo: "Ventas con estado de entrega incorrecto",
          empresaNombre,
          descripcionFiltros:
            "Ventas en estado Entregado o Entregado parcialmente cuyo estado no cuadra con lo entregado en sus líneas, " +
            "o con líneas mal guardadas. En rojo: ya tienen salidas de inventario, o tienen líneas mal guardadas.",
        }),
      },
    ],
    `Ventas_Estado_Incorrecto_${limpiarNombreArchivo(empresaNombre)}_${moment().format("YYYY-MM-DD")}`
  );
};
